import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/src/styles/main.sass';

Vue.use(Vuetify);

const primaryColor = '#DC3522';
const secondaryColor = '#181818';

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: primaryColor,
        primaryMain: '#DC3522',
        primaryMainText: '#ffffff',
        primaryMainInverted: '#DC3522',
        secondary: secondaryColor,
        anchor: '#8c9eff',
      },
    },
  },
  icons: {
    iconfont: 'fa',
  },
});

const ignoreWarnMessage =
  'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg === ignoreWarnMessage) {
    msg = null;
    vm = null;
    trace = null;
  }
};
